// extracted by mini-css-extract-plugin
module.exports = {"blueLink":"ConfirmGasBackGiftCardDetails-module__blueLink___27S4O"};